import * as React from 'react';
import * as _ from 'lodash';

import Scenario from '../../models/Scenario';
import { SuccessCriteria } from '../../models/project/SuccessCriteria';
import StatisticsCalculator from '../../services/statistics/StatisticsCalculator';

class Scenarios extends React.Component<{
  scenarios: Scenario[],
  successCriteria?: SuccessCriteria
}, {}> {
  constructor(props) {
    super(props);
  }

  public render() {
    const workEstimateSanity = StatisticsCalculator.isWorkEstimateSane(this.props.scenarios)
    const customEstimateTitle = _.isUndefined(this.props.successCriteria) ? 'Custom estimate' : this.props.successCriteria.customEstimateTitle;

    const eventRows = this.props.scenarios.map((scenario, index) => {
      return <tr key={"row-" + index.toString()}>
        <td>{index+1}</td>
        <td>{new Intl.NumberFormat('de-DE', { 'style': 'percent', 'minimumFractionDigits': 0 }).format(scenario.probability)}</td>
        {workEstimateSanity && <td>{scenario.getTimeEstimate()}</td>}
        <td>{scenario.getCustomEstimate()}</td>
        <td>{scenario.formatAsString()}</td>
      </tr>
    });

    return (
      <React.Fragment>
        <h2>Scenarios</h2>
        <table className="table table-striped table-borderless">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Probability</th>
              {workEstimateSanity && <th scope="col">Work estimate</th>}
              <th scope="col">{customEstimateTitle}</th>
              <th scope="col">Events</th>
            </tr>
          </thead>
          <tbody>
            {eventRows}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default Scenarios;


// WEBPACK FOOTER //
// ./src/components/scenarios/Scenarios.tsx